var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticStyle: { top: "60px" },
      attrs: {
        title: "创建配送任务",
        width: 760,
        visible: _vm.visible,
        confirmLoading: _vm.saving,
        maskClosable: false,
        cancelText: "取消",
        okText: "创建任务",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleClose },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c(
            "a-form",
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 18 },
                    label: "配送员",
                    required: "",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择配送员（本租户员工）" },
                      model: {
                        value: _vm.courierUserId,
                        callback: function ($$v) {
                          _vm.courierUserId = $$v
                        },
                        expression: "courierUserId",
                      },
                    },
                    _vm._l(_vm.couriers, function (c) {
                      return _c(
                        "a-select-option",
                        { key: c.id, attrs: { value: c.id } },
                        [_vm._v(_vm._s(c.username))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 18 },
                    label: "出库单",
                    required: "",
                    extra:
                      "仅可选择已出库（收单流程、订单状态=已出库）且未挂在未完成任务上的出库单",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        mode: "multiple",
                        placeholder: "请选择要配送的出库单（可多选）",
                      },
                      on: { change: _vm.handleBillsChange },
                      model: {
                        value: _vm.selectedBillIds,
                        callback: function ($$v) {
                          _vm.selectedBillIds = $$v
                        },
                        expression: "selectedBillIds",
                      },
                    },
                    _vm._l(_vm.bills, function (b) {
                      return _c(
                        "a-select-option",
                        { key: b.xsckHeadId, attrs: { value: b.xsckHeadId } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(b.xsckNo) +
                              "（" +
                              _vm._s(b.customerName || "客户") +
                              "）\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.stops.length > 0
                ? _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 19 },
                        label: "配送点",
                        extra:
                          "地址默认取客户档案，可补录修改；通过上移/下移调整配送顺序",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "stop-list" },
                        _vm._l(_vm.stops, function (stop, index) {
                          return _c(
                            "div",
                            { key: stop.xsckHeadId, staticClass: "stop-row" },
                            [
                              _c("div", { staticClass: "stop-seq" }, [
                                _vm._v(_vm._s(index + 1)),
                              ]),
                              _c("div", { staticClass: "stop-main" }, [
                                _c("div", { staticClass: "stop-head" }, [
                                  _c("span", { staticClass: "stop-customer" }, [
                                    _vm._v(_vm._s(stop.customerName || "客户")),
                                  ]),
                                  _c("span", { staticClass: "stop-no" }, [
                                    _vm._v("出库单 " + _vm._s(stop.xsckNo)),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "stop-addr" },
                                  [
                                    _c("a-input", {
                                      attrs: {
                                        placeholder: "配送地址（缺失请补录）",
                                        size: "small",
                                      },
                                      model: {
                                        value: stop.address,
                                        callback: function ($$v) {
                                          _vm.$set(stop, "address", $$v)
                                        },
                                        expression: "stop.address",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "stop-ops" },
                                [
                                  _c("a-button", {
                                    attrs: {
                                      size: "small",
                                      icon: "arrow-up",
                                      disabled: index === 0,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.moveStop(index, -1)
                                      },
                                    },
                                  }),
                                  _c("a-button", {
                                    attrs: {
                                      size: "small",
                                      icon: "arrow-down",
                                      disabled: index === _vm.stops.length - 1,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.moveStop(index, 1)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.stops.length > 0
                ? _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 18 },
                        label: "路线方案",
                      },
                    },
                    [
                      _vm.plans.length > 0
                        ? [
                            _c(
                              "a-radio-group",
                              {
                                model: {
                                  value: _vm.selectedRouteMode,
                                  callback: function ($$v) {
                                    _vm.selectedRouteMode = $$v
                                  },
                                  expression: "selectedRouteMode",
                                },
                              },
                              _vm._l(_vm.plans, function (p) {
                                return _c(
                                  "a-radio",
                                  {
                                    key: p.mode,
                                    staticClass: "plan-radio",
                                    attrs: { value: p.mode },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(p.modeName) +
                                        "：" +
                                        _vm._s(p.summary) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                            _c("div", { staticClass: "plan-tip" }, [
                              _vm._v(
                                "选定方案将存入任务并作为下次默认方案；也可不选择，直接手工排序配送点"
                              ),
                            ]),
                          ]
                        : [
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  icon: "compass",
                                  loading: _vm.planning,
                                  disabled: _vm.stops.length < 2,
                                },
                                on: { click: _vm.handlePlanRoute },
                              },
                              [_vm._v("规划路线")]
                            ),
                            _vm.planTip
                              ? _c("span", { staticClass: "plan-tip-inline" }, [
                                  _vm._v(_vm._s(_vm.planTip)),
                                ])
                              : _vm._e(),
                            _c("div", { staticClass: "plan-tip" }, [
                              _vm._v("未选择高德方案时按手工排序配送"),
                            ]),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }